// import {AppSettings} from '../constants';
// import ManageRFS from './Containers/manage-rfs';
// import AddRFS from './Containers/add-rfs';
// import AddScheduleRFS from './Containers/add-schedule-rfs';
// import RFSDetail from './Containers/RFSDetail';
// import EocListItems from './Containers/eoc-list-items';
// import Loading from 'components/Loading';
// import Loadable from 'react-loadable';

// const HomeownerEOC = Loadable({
//   loader: () => import('./Containers/eoc-list-items'),
//   loading: Loading
// });

// export default [
//   {
//     path: '/request-for-services',
//     component: ManageRFS,
//     private: true,
//     portal: ['Builder'],
//     menu: {
//       name: 'Requests for service',
//       order: 7,
//       icons: 'icon-standard-requests-ic',
//       // className: AppSettings.clientTypeValue !== 'Homeowner' ? 'menu-divide' : '',
//       condition: () => {
//         return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
//       }
//     }
//   },
//   {
//     path: '/request-for-services/:RFSID',
//     component: RFSDetail,
//     portal: ['Builder'],
//     private: true
//   },
//   {
//     path: '/request-for-services/add',
//     component: AddRFS,
//     portal: ['Builder'],
//     private: true
//   },
//   {
//     path: '/request-for-services/add-schedule-request',
//     component: AddScheduleRFS,
//     portal: ['Builder'],
//     private: true
//   },
 
//   {
//     path: '/request-for-services/electronic-orientation-checklists/:RFSID',
//     component: HomeownerEOC,
//     portal: ['Builder'],
//     private: true
//   }
// ];
import {AppSettings} from '../constants';
import ManageRFS from './Containers/manage-rfs';
import AddRFS from './Containers/add-rfs';
import AddScheduleRFS from './Containers/add-schedule-rfs';
import RFSDetail from './Containers/RFSDetail';
import EocListItems from './Containers/eoc-list-items';
import Loading from 'components/Loading';
import Loadable from 'react-loadable';

const HomeownerEOC = Loadable({
  loader: () => import('./Containers/eoc-list-items'),
  loading: Loading
});

export default [
  {
    path: '/request-for-services',
    component: ManageRFS,
    private: true,
    portal: ['Builder'],
    menu: {
      name: 'Requests for service',
      order: 7,
      icons: 'icon-standard-requests-ic',
      // className: AppSettings.clientTypeValue !== 'Homeowner' ? 'menu-divide' : '',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  },
  {
    path: '/request-for-services/add',
    component: AddRFS,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/request-for-services/add-schedule-request',
    component: AddScheduleRFS,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/request-for-services/:RFSID',
    component: RFSDetail,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/request-for-services/electronic-orientation-checklists/:RFSID',
    component: HomeownerEOC,
    portal: ['Builder'],
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/Request-Services/routes.js